import { DeclareMethod } from '/imports/methods';
import { FileMeta } from '/imports/types';

export interface RealtyIncomeBillingParams { batch: number, startDate: string, endDate: string, issuedDate: string, dueDate: string, ledger: FileMeta, lastBillDate?: string }
export const generateRealtyIncomeBills = DeclareMethod<RealtyIncomeBillingParams, number>('generateRealtyIncomeBills');
interface RealtyIncomeSendBillsParams { billIds: string[], subject: string, html: string, recipients: string, ccEmails?: string, test?: boolean, accessCode?: string }
export const sendRealtyIncomeBills = DeclareMethod<RealtyIncomeSendBillsParams, number>('sendRealtyIncomeBills');
